/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import { useMemo } from 'react';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';

import cn from '../../utils/styleHelpers';
import { inlineComponents } from './inlineStyles';
import { components } from './styles';
import HeRefLink from './HeRefLink';

const markdownComponents = { ...components, a: HeRefLink };
const markdownInlineComponents = { ...inlineComponents, a: HeRefLink };

function MarkdownRenderer({
    children,
    classname,
    inline = false,
}: any) {
    const schema = useMemo(() => ({
        ...defaultSchema,
        protocols: {
            ...(defaultSchema as any).protocols,
            href: [...(((defaultSchema as any).protocols?.href) || []), 'he'],
        },
        attributes: {
            ...defaultSchema.attributes,
            code: [...(defaultSchema.attributes?.code || []), 'className'],
            span: [...(defaultSchema.attributes?.span || []), 'className'],
        }
    }), []);

    const urlTransform = useMemo(
        () => (value: string) => {
            if (value.startsWith('he://')) return value;
            return defaultUrlTransform(value);
        },
        []
    );

    return (
        <div
            className={cn(
                "prose prose-sm max-w-none prose-purple dark:prose-invert [&_p]:text-sm [&_p]:leading-[1.8] [&_li]:text-sm [&_li]:leading-[1.8] [&_ul]:text-sm [&_ol]:text-sm",
                classname
            )}
        >
            <ReactMarkdown
                components={inline ? markdownInlineComponents : markdownComponents}
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw, [rehypeSanitize, schema]]}
                urlTransform={urlTransform}
            >
                {children}
            </ReactMarkdown>
        </div>
    );
}

export default MarkdownRenderer;
